// extracted by mini-css-extract-plugin
module.exports = {"e1krvuf7":"e1krvuf7"};